import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq, axiosReq2 } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { apiUrlFaceSar, apiUrlWordCloudImageSar } from "../../../commons/inFormTypes";
import PhotoUpload from "../MainComponents/FileUpload"
import ClipLoader from "react-spinners/ClipLoader"

const AddModalAdminFace = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, type }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();
    const [dataimage, setDataImage] = useState();
    const [files, setFiles] = useState();


    const [allValues, setAllValues] = useState({
        Name: '',


    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,


    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };

    const downloadImage = (base64Data, filename = 'generated-image.png') => {
        const link = document.createElement('a');
        link.href = base64Data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const addAdmin = async () => {

        setSnipper(true);

        try {
            if (!files) {
                setEroor("لطفا ابتدا یک فایل انتخاب کنید");
                setShowErrorModalStep1(true);
                return;
            }
            var res = allFull();
            if (!res) {
                setEroor("لطفا نام را وارد کنید");
                setShowErrorModalStep1(true);
                return;
            }
            const formData = new FormData();
            // "file" must match your curl field name: -F 'file=@test.txt;type=text/plain'
            formData.append("file", files, files.name);
            formData.append("collection_name", allValues.Name);

            const { data, status } = await axios.post(
                apiUrlFaceSar + "knowledge/create",
                formData,
                {
                    headers: {
                        // Let the browser set the multipart boundary
                        Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",

                    },
                }
            );

            if (status >= 200 && status < 300) {
                alert("موفقیت أمیز");
                setRecheck(!reCheck)
                setShowModal(false)
            } else {
                setEroor(data || "خطا در پردازش فایل");
                setShowErrorModalStep1(true);
            }
        } catch (err) {
            setEroor(
                err?.response?.data?.message ||
                err?.message ||
                "خطا در برقراری ارتباط با سرور"
            );
            setShowErrorModalStep1(true);
        } finally {
            setSnipper(false);
        }
    }

    const editAdmin = async () => {
        setSnipper(true);

        try {
            if (!files) {
                setEroor("لطفا ابتدا یک فایل انتخاب کنید");
                setShowErrorModalStep1(true);
                return;
            }

            const formData = new FormData();
            console.log(33)
            console.log(data)
            // "file" must match your curl field name: -F 'file=@test.txt;type=text/plain'
            formData.append("file", files, files.name);
            formData.append("collection_name", data);

            const { data2, status } = await axios.post(
                apiUrlFaceSar + "knowledge/update",
                formData,
                {
                    headers: {
                        // Let the browser set the multipart boundary
                        Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,
                        Accept: "application/json",
                    },
                }
            );

            if (status >= 200 && status < 300) {
                //   setDataImage(data?.image);
                alert("موفقیت أمیز")
                setRecheck(!reCheck)
                setShowModal(false)
            } else {
                setEroor(data2 || "خطا در پردازش فایل");
                setShowErrorModalStep1(true);
            }
        } catch (err) {
            setEroor(
                err?.response?.data?.message ||
                err?.message ||
                "خطا در برقراری ارتباط با سرور"
            );
            setShowErrorModalStep1(true);
        } finally {
            setSnipper(false);
        }
    };


    // const editAdmin = async () => {
    //     setSnipper(true)


    //     const formData = new FormData();
    //     formData.append("file", files);

    //     const dataUser = await axios.post(apiUrlWordCloudImageSar + "generate-wordcloud", {
    //         formData,


    //     }, {
    //         headers: {
    //             "Content-Type": "multipart/form-data",
    //             Accept: "application/json",
    //             // "Authorization": "Bearer " + props.token,
    //         }
    //     });
    //     console.log(dataUser)
    //     console.log(dataUser?.data?.image)
    //     if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {

    //         // setRecheck(!reCheck)
    //         // setShowModal(false)
    //         setDataImage(dataUser?.data?.image)
    //         // alert("موفقیت آمیز");
    //     }


    //     else {
    //         console.log(allValuesError)
    //         setEroor(dataUser?.data)

    //         setShowErrorModalStep1(true);
    //     }


    // }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o != "IsAdmin") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        {/* {dataimage ?
                            <img
                                src={dataimage}
                                className="image-message cursor-pointer"
                                alt="Base64"
                                style={{ width: "400px", height: "auto" }}
                                onClick={() => downloadImage(dataimage)}
                            />
                            :
                            null} */}
                        {type == "create" ?
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Name"
                                    onChange={changeHandler}
                                    // value={allValues?.expertise}
                                    onInput={maxLengthCheck}

                                    maxLength={100} />
                                {
                                    allValuesError.expertise ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            : null}
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">فایل</span>
                                <PhotoUpload
                                    setFile={setFiles}
                                />
                            </div>






                        </div>

                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => type == "create" ? addAdmin() : editAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]">
                                {
                                    snipper ?
                                        <div className="flex justify-center items-center">

                                            <ClipLoader
                                                color={"#000000"}
                                                loading={snipper}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                        :
                                        <p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p>}
                            </button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalAdminFace;